import React, { Component } from 'react';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import loadingCircle from '../../images/ajax-loader.gif';
// import DataTable from 'react-data-table-component';
import ReactTableExample from './ReactTableExample'

class Tableanalyze extends Component{

    constructor(props) {
        super(props)  
        this.state={
            pythonBody:{
                img_folder:this.props.props.img_folder+"/"+this.props.props.uploadedFileName,
                model:[]
            },
            classifyModel:[],
            colorModel:[],
            imgAlignment:[]
        }      
    }

    containsObject(obj, list) {
        var i;
        for (i = 0; i < list.length; i++) {
            var val = list[i]
            if (JSON.stringify(list[i]) === JSON.stringify(obj) ) {
                return true;
            }
        }
    
        return false;
    }

    exportClassifyExcel() {
   
    var tablevalue = []
    if(this.props.props.classifyModel!=undefined && this.props.props.classifyModel.Image_name!=undefined 
        && this.props.props.classifyModel.Image_name.length>0){
            tablevalue=this.props.props.classifyModel
        }
    else if(this.props.props.colorModel!=undefined && this.props.props.colorModel.Image_name!=undefined 
        && this.props.props.colorModel.Image_name.length>0){
        tablevalue=this.props.props.colorModel
    }    
    var ImageAnalysis = [];
    for (var i = 0; i < tablevalue.Image_name.length; i++) {
        var shotConfValue="-"
        var shotNameValue="-"
        
        if(tablevalue.Back_Not_Back!=undefined && tablevalue.Back_Not_Back.length>0){
            var shotConf=[(tablevalue.Back_Not_Back_conf[i][i]==null?0:tablevalue.Back_Not_Back_conf[i][i]), 
            (tablevalue.Front_Not_Front_conf[i][i]==null?0:tablevalue.Front_Not_Front_conf[i][i]),
            (tablevalue.Side_Not_Side_conf[i][i]==null?0:tablevalue.Side_Not_Side_conf[i][i]),
            (tablevalue.Top_Not_Top_conf[i][i])==null?0:tablevalue.Top_Not_Top_conf[i][i]]

        var shotValue=[(tablevalue.Back_Not_Back[i][i]==null?0:tablevalue.Back_Not_Back[i][i]), 
            (tablevalue.Front_Not_Front[i][i]==null?0:tablevalue.Front_Not_Front[i][i]),
            (tablevalue.Side_Not_Side[i][i]==null?0:tablevalue.Side_Not_Side[i][i]),
            (tablevalue.Top_Not_Top[i][i])==null?0:tablevalue.Top_Not_Top[i][i]]                
        console.log("Shot Confidence............"+ Math.max(...shotConf))     
        console.log("Shot............"+  shotConf.indexOf(Math.max(...shotConf))) 
        var correctIndex  = shotConf.indexOf(Math.max(...shotConf))

        var shotConfValue=  Math.round(Math.max(...shotConf)*100,2)  
        var shotNameValue=  shotValue[correctIndex] 
        }
        
        var BlankImprint=(tablevalue.Blank_Imprint!=undefined)?tablevalue.Blank_Imprint[i][i]:"-"
        var BlankImprint_conf=(tablevalue.Blank_Imprint_conf!=undefined)?tablevalue.Blank_Imprint_conf[i][i]:"-"
        var SingleMulti=(tablevalue.Multi_Single!=undefined)?tablevalue.Multi_Single[i][i]:"-"
        var SingleMulti_conf=(tablevalue.Multi_Single_conf!=undefined)?tablevalue.Multi_Single_conf[i][i]:"-" 

        var colorName=(this.props.props.colorModel.PCNA_colour!=undefined)?this.props.props.colorModel.PCNA_colour[i][i]:"-"
        var colorRGB=(this.props.props.colorModel.RGB_value!=undefined)?this.props.props.colorModel.RGB_value[i][i]:"-"

        var excelData = {
            "Product Name": tablevalue.Image_name[i][i],
            "Blank-Imprint": BlankImprint,
            "Blank-Imprint Confidence": BlankImprint_conf,
            "Shot View": shotNameValue,
            "Shot View Confidence": shotConfValue,
            "Single-Multi": SingleMulti,
            "Single-Multi Confidence": SingleMulti_conf  ,   
            "PCNA Color":  colorName,
            "RGB value":   JSON.stringify(colorRGB) 
        };
        ImageAnalysis.push(excelData)
    }
    
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const fileName = "ImageMetrics";

    const ws = XLSX.utils.json_to_sheet(ImageAnalysis);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);

    // document.getElementById("exportExcelBtn").removeAttribute("disabled");
    // document.getElementById("exportExcelBtn").innerHTML = "Export";
    }

    exportImageWiseExcel(){
        debugger
        if(this.props.props.imgAlignment!=undefined && this.props.props.imgAlignment.Alignment!=undefined){
            var ImageWiseValue = [];
            var tablevalue=this.props.props.imgAlignment.Alignment[0].Product_code;

            for (var i = 0; i < tablevalue.length; i++) {
                var Product_Name=(this.props.props.imgAlignment.Alignment[0].Product_code!=undefined)?this.props.props.imgAlignment.Alignment[0].Product_code[i][i]:"-"
                var ImageName1=(this.props.props.imgAlignment.Alignment[1].Image_name_1!=undefined)?this.props.props.imgAlignment.Alignment[1].Image_name_1[i][i]:"-"
                var ImageName2=(this.props.props.imgAlignment.Alignment[2].Image_Name_2!=undefined)?this.props.props.imgAlignment.Alignment[2].Image_Name_2[i][i]:"-"
                var AlignMentPerc=(this.props.props.imgAlignment.Alignment[4].SSIM_perc!=undefined)?this.props.props.imgAlignment.Alignment[4].SSIM_perc[i][i]:"-"
                var excelData = {
                    "Product Name" : Product_Name,
                    "Image Name 1" : ImageName1,
                    "Image Name 2" : ImageName2,                   
                    "Alignment %" : AlignMentPerc
                };
                ImageWiseValue.push(excelData)
            }
            
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const fileExtension = '.xlsx';
            const fileName = "ImageWise Comparison";
        
            const wsIV = XLSX.utils.json_to_sheet(ImageWiseValue);
            const wb = { Sheets: { 'data': wsIV }, SheetNames: ['data'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, fileName + fileExtension);
        }        
    }

    exportProductWiseExcel(){
        var ProductWiseCompare = []
        debugger
        if(this.props.props.imgAlignment!=undefined && this.props.props.imgAlignment.Alignment!=undefined){
            var ImageWiseValue = [];
            var tablevalue=this.props.props.imgAlignment.Alignment[0].Product_code;

            for (var i = 0; i < tablevalue.length; i++) {

                var Product_Name=(this.props.props.imgAlignment.Alignment[0].Product_code!=undefined)?this.props.props.imgAlignment.Alignment[0].Product_code[i][i]:"-"
                var valMinimum=(this.props.props.imgAlignment.Alignment[5].Minimum!=undefined)?this.props.props.imgAlignment.Alignment[5].Minimum[i][i]:"0"
                var valMaximum=(this.props.props.imgAlignment.Alignment[6].Maximum!=undefined)?this.props.props.imgAlignment.Alignment[6].Maximum[i][i]:"0"
                var valMedian=(this.props.props.imgAlignment.Alignment[7].Median!=undefined)?this.props.props.imgAlignment.Alignment[7].Median[i][i]:"0"
               
              var  ProductWiseObj = {
                    "Product Name" : Product_Name,
                    "Minimum" :(valMinimum!=0?Number.parseFloat(valMinimum * 100).toFixed(2):"-"),
                    "Maximum" :(valMaximum!=0?Number.parseFloat(valMaximum * 100).toFixed(2):"-"),
                    "Median" : (valMedian!=0?Number.parseFloat(valMedian * 100).toFixed(2):"-")
                } 
                if(ProductWiseCompare.length <= 0){
                     ProductWiseCompare.push(ProductWiseObj)
                }
                else{
                    var isObjPresent = this.containsObject(ProductWiseObj, ProductWiseCompare)
                    if(!isObjPresent){
                         ProductWiseCompare.push(ProductWiseObj)
                    }
                }
                
            }
            
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const fileExtension = '.xlsx';
            const fileName = "ProductWise Comparison";
        
            const wsIV = XLSX.utils.json_to_sheet(ProductWiseCompare);
            const wb = { Sheets: { 'data': wsIV }, SheetNames: ['data'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, fileName + fileExtension);
        }        
    }
    
    render(){
// console.log("//////////////")
// debugger
// console.log(this.props.props.imgAlignment)
// console.log(typeof this.props.props.imgAlignment)
// console.log("//////////////")


        var NewDataListColor = []
        var ImageWiseCompare = []
        var ProductWiseCompare = []
        var ColorList = []  

        var ColumnList = []
        var objName =  {
            Header : ' ',
            columns: [
                {
                  Header: 'Product Name',
                  accessor: 'Product Name',
                  filter: "fuzzyText"
                }
              ]
        }
        
        var ImprintObj = {
            Header: 'Blank Imprint',
            columns: [
                    {
                        Header: 'Prediction',
                        accessor: 'Blank_Imprint_Prediction',
                    },
                    {
                        Header: 'Confidence %',
                        accessor: 'Blank_Imprint_Confidence',
                    }
            ]
        }

        var ShotObj = {
            Header: 'Shot View',
            columns: [
                {
                Header: 'Prediction',
                accessor: 'Shot_Prediction',
                },
                {
                Header: 'Confidence %',
                accessor: 'Shot_Confidence',
                }
            ]
        }

        var SingleMultiObj =  {
            Header: 'Single Multi',
            columns: [
                {
                Header: 'Prediction',
                accessor: 'Multi_Single_Prediction',
                },
                {
                Header: 'Confidence %',
                accessor: 'Multi_Single_Confidence',
                }
            ]
        }

        var ColorObj = {
            Header: 'Color Categorization',
            columns: [
                {
                Header: 'Color Name',
                accessor: 'PCNA_colour_Prediction',
                },
                {
                Header: 'RGB Values',
                accessor: 'RGB_value_Confidence',
                }
            ]
        } 
        
        var values = this.props
        var NewDataListColorColumns = []
        var ImageWiseCompareColumns = []

        NewDataListColorColumns.push(objName)
        if(values.props.Blank_Imprint === true){
            NewDataListColorColumns.push(ImprintObj)
        }
        if(values.props.Shot_View === true){
            NewDataListColorColumns.push(ShotObj)
        }
        if(values.props.Single_Multi === true){
            NewDataListColorColumns.push(SingleMultiObj)
        }
        if(values.props.Color_Categorization === true ){
            NewDataListColorColumns.push(ColorObj)
        }
        if(values.props.ImageCompare === true){
            ImageWiseCompareColumns = [
               {
                   Header : ' ',
                   columns: [
                       {
                         Header: 'Product Name',
                         accessor: 'Product Name',
                         filter: "fuzzyText"
                       }
                     ]
               },
               {
                   Header : ' ',
                   columns: [
                       {
                         Header: 'Image Name 1',
                         accessor: 'Image Name 1',
                         filter: "fuzzyText"
                       }
                     ]
               },
               {
                   Header : ' ',
                   columns: [
                       {
                         Header: 'Image Name 2',
                         accessor: 'Image Name 2',
                         filter: "fuzzyText"
                       }
                     ]
               },
            //    {
            //        Header : ' ',
            //        columns: [
            //            {
            //              Header: 'SSIM',
            //              accessor: 'SSIM',
            //              filter: "fuzzyText"
            //            }
            //          ]
            //    },
               {
                   Header : ' ',
                   columns: [
                       {
                         Header: 'Alignment %',
                         accessor: 'Alignment %',
                         filter: "fuzzyText"
                       }
                     ]
               }
         ];
      
        var ProductWiseCompareColumns = [
            {
                Header : ' ',
                columns: [
                    {
                      Header: 'Product Name',
                      accessor: 'Product Name',
                      filter: "fuzzyText"
                    }
                  ]
            },
            {
                Header : ' ',
                columns: [
                    {
                      Header: 'Minimum',
                      accessor: 'Minimum',
                      filter: "fuzzyText"
                    }
                  ]
            },
            {
                Header : ' ',
                columns: [
                    {
                      Header: 'Maximum',
                      accessor: 'Maximum',
                      filter: "fuzzyText"
                    }
                  ]
            },
            {
                Header : ' ',
                columns: [
                    {
                      Header: 'Median',
                      accessor: 'Median',
                      filter: "fuzzyText"
                    }
                  ]
            }
          ];
       }


       var ColorColumns = [
        {
            Header : ' ',
            columns: [
                {
                  Header: 'Product Name',
                  accessor: 'Product Name',
                  filter: "fuzzyText"
                }
              ]
        },
        {
            Header : ' ',
            columns: [
                {
                  Header: 'Product Name',
                  accessor: 'Product Name',
                  filter: "fuzzyText"
                }
              ]
        },
        {
            Header: 'Color Categorization',
            columns: [
                {
                Header: 'Color Name',
                accessor: 'PCNA_colour_Prediction',
                },
                {
                Header: 'RGB Values',
                accessor: 'RGB_value_Confidence',
                }
            ]
        }
      ];
        
    return (

<div className="table-a shadow">
{/* {(this.props!=undefined && this.props.props.analyseClick==true 
// && (this.props.props.classifyModel==undefined || this.props.props.classifyModel.Image_name==undefined
//                                  || this.props.props.classifyModel.Image_name.length==0) &&
//                             (this.props.props.colorModel==undefined || this.props.props.colorModel.Image_name==undefined
//                                     || this.props.props.colorModel.Image_name.length==0)  
                            )?
                            <div className="row ml-12 mb-4 ">   <img src={loadingCircle} className="offset-md-6" /> </div>: */}
                            <React.Fragment> <div className="row ml-12 mb-4 tab-b">
                                                        <ul class="nav nav-tabs" id="myTab1" role="tablist">
															<li class="nav-item">
																<a class="nav-link active" id="home-tab-1" data-toggle="tab" href="#home-1">
																	
																	<span class="nav-text h4">Image Analysis</span>
																</a>
															</li>
                                                            {(this.props.props.imgAlignment!=undefined && this.props.props.imgAlignment.Alignment!=undefined)?
                                                            <React.Fragment>
                                                            <li class="nav-item">
                                                            <a class="nav-link" id="profile-tab-1" data-toggle="tab" href="#home-2" aria-controls="profile">
                                                                
                                                                <span class="nav-text h4">Image Comparison-Image Wise</span>
                                                            </a>
                                                        </li>
                                                        <li class="nav-item">
                                                            <a class="nav-link" id="profile-tab-2" data-toggle="tab" href="#home-3" aria-controls="profile2">
                                                                
                                                                <span class="nav-text h4">Image Comparison-Product Wise</span>
                                                            </a>
                                                        </li>
                                                        </React.Fragment>
                                                            :""}
															
                                                            </ul>
                                                    </div>
                                                    <div class="tab-content mt-5" id="myTabContent1">
															<div class="tab-pane fade show active" id="home-1" role="tabpanel" aria-labelledby="home-tab-1">

                                                            <div className="row">
           
            <div className="col-md-2 offset-md-10 mr-0 pr-0">
            <button className="btn btn-dark w-100  " onClick={()=>this.exportClassifyExcel()}>Export Report</button>
            </div>
        
                      </div>
                      <div className="row ml-10 mt-6">
                         
                            {(this.props!=undefined && this.props.props.analyseClick==true && 
                            (this.props.props.classifyModel==undefined || this.props.props.classifyModel.Image_name==undefined
                                 || this.props.props.classifyModel.Image_name.length==0) &&
                            (this.props.props.colorModel==undefined || this.props.props.colorModel.Image_name==undefined
                                    || this.props.props.colorModel.Image_name.length==0) && 
                            (this.props.props.imgAlignment==undefined || this.props.props.imgAlignment.Alignment==undefined
                                        || this.props.props.imgAlignment.Alignment.length==0)  
                            )?
                        
                                 <img src={loadingCircle} className="offset-md-6" />
                            :
                            <React.Fragment>
                               {(this.props!=undefined && this.props.props.classifyModel!=undefined && 
                               this.props.props.classifyModel.Image_name!=undefined && this.props.props.classifyModel.Image_name.length>0)?
                               
                               <React.Fragment> 
                               
                            {(this.props.props.classifyModel.Image_name!=undefined && this.props.props.classifyModel.Image_name.length>0)?
                            <React.Fragment>
                                {this.props.props.classifyModel.Image_name.map((name,index)=>{
                                    var obj = {}
                                    var shotConf = []
                                    var shotValue = []
                                    var shotConfValue = ""
                                    var shotNameValue = ""

                                    if(this.props.props.classifyModel.Back_Not_Back!=undefined && this.props.props.classifyModel.Back_Not_Back.length>0){
                                        shotConf=[(this.props.props.classifyModel.Back_Not_Back_conf[index][index]==null?0:this.props.props.classifyModel.Back_Not_Back_conf[index][index]), 
                                            (this.props.props.classifyModel.Front_Not_Front_conf[index][index]==null?0:this.props.props.classifyModel.Front_Not_Front_conf[index][index]),
                                            (this.props.props.classifyModel.Side_Not_Side_conf[index][index]==null?0:this.props.props.classifyModel.Side_Not_Side_conf[index][index]),
                                            (this.props.props.classifyModel.Top_Not_Top_conf[index][index])==null?0:this.props.props.classifyModel.Top_Not_Top_conf[index][index]]

                                        shotValue=[(this.props.props.classifyModel.Back_Not_Back[index][index]==null?0:this.props.props.classifyModel.Back_Not_Back[index][index]), 
                                            (this.props.props.classifyModel.Front_Not_Front[index][index]==null?0:this.props.props.classifyModel.Front_Not_Front[index][index]),
                                            (this.props.props.classifyModel.Side_Not_Side[index][index]==null?0:this.props.props.classifyModel.Side_Not_Side[index][index]),
                                            (this.props.props.classifyModel.Top_Not_Top[index][index])==null?0:this.props.props.classifyModel.Top_Not_Top[index][index]]                
                                        
                                        var correctIndex  = shotConf.indexOf(Math.max(...shotConf))
                                        var shotConfValue=  Math.round(Math.max(...shotConf)*100,2)  
                                        var shotNameValue=  shotValue[correctIndex]
                                    }
                                    
                                    obj = {
                                        "Product Name" : name[index],
                                        "Blank_Imprint_Prediction" : this.props.props.classifyModel.Blank_Imprint!=undefined?
                                                            this.props.props.classifyModel.Blank_Imprint[index][index] : "",
                                        "Blank_Imprint_Confidence" : this.props.props.classifyModel.Blank_Imprint_conf!=undefined?
                                                            Math.round(this.props.props.classifyModel.Blank_Imprint_conf[index][index] * 100,2) : "",
                                        "Shot_Prediction" : this.props.props.classifyModel.Back_Not_Back!=undefined?
                                                                shotNameValue : "",
                                        "Shot_Confidence" : this.props.props.classifyModel.Back_Not_Back_conf!=undefined?
                                                                shotConfValue : "",
                                        "Multi_Single_Prediction" : this.props.props.classifyModel.Multi_Single!=undefined?
                                                            this.props.props.classifyModel.Multi_Single[index][index] : "",
                                        "Multi_Single_Confidence" : this.props.props.classifyModel.Multi_Single_conf!=undefined? 
                                                            Math.round(this.props.props.classifyModel.Multi_Single_conf[index][index] * 100,2) : "",
                                        "PCNA_colour_Prediction" : this.props.props.colorModel!=undefined && this.props.props.colorModel.PCNA_colour!=undefined ?
                                                        this.props.props.colorModel.PCNA_colour[index][index] : "",
                                        "RGB_value_Confidence" : this.props.props.colorModel!=undefined && this.props.props.colorModel.PCNA_colour!=undefined ?
                                                        JSON.stringify(this.props.props.colorModel.RGB_value[index][index]): ""
                                    }

                                    NewDataListColor.push(obj)
                                
                                    })}
                                    {NewDataListColor.length > 0 ?
                                   

                                    <ReactTableExample data = {NewDataListColor} {...this.state} {...this.props} 
                                    columns = {NewDataListColorColumns}/>
                                    : ""}
                                    </React.Fragment>
                                    :""}
                                    </React.Fragment>
                            :
                            <React.Fragment>
                            {(this.props.props.colorModel.Image_name!=undefined && this.props.props.colorModel.Image_name.length>0)?
                            <React.Fragment>
                            {this.props.props.colorModel.Image_name.map((ImageName,index)=>{
                                var colorObj = {}

                                colorObj = {
                                    "Product Name" : ImageName[index],
                                    "PCNA_colour_Prediction" : this.props.props.colorModel.PCNA_colour[index][index],
                                    "RGB_value_Confidence" : JSON.stringify(this.props.props.colorModel.RGB_value[index][index])
                                }

                                ColorList.push(colorObj)
                            
                            })}
                            {ColorList.length > 0 ?
                           
                            <ReactTableExample data = {ColorList} {...this.state} {...this.props} columns = {ColorColumns}/>
                            : ""}
                            </React.Fragment>
                            :""}
                            </React.Fragment>
                            
                            }
                            </React.Fragment>
                                    }
                        
                      </div>
                     
                                                            </div>
                                                            <div class="tab-pane fade " id="home-2" role="tabpanel" aria-labelledby="home-tab-2">
                                                            <div className="row">
                                                            
                                                        <div className="col-md-2 offset-md-4 mr-0 pr-0">
                                                        <button className="btn btn-dark w-100  " onClick={()=>this.exportImageWiseExcel()}>Export Report</button>
                                                        </div>
        
                      </div>
                      <div className="row ml-10 mt-6">
                                {this.props.props.imgAlignment!=undefined && this.props.props.imgAlignment.Alignment!=undefined?
                            <React.Fragment>
                                {this.props.props.imgAlignment.Alignment[0].Product_code.map((imageName, index)=>{
                                    debugger
                                    var imagewise_obj = {}
                                    
                                      imagewise_obj = {
                                        "Product Name" : imageName[index],
                                        "Image Name 1" : this.props.props.imgAlignment.Alignment[1].Image_name_1[index][index],
                                        "Image Name 2" : this.props.props.imgAlignment.Alignment[2].Image_Name_2[index][index],
                                        //"SSIM" : Number.parseFloat(this.props.props.imgAlignment.Alignment[3].SSIM[index][index]).toFixed(2),
                                        "Alignment %" : this.props.props.imgAlignment.Alignment[4].SSIM_perc[index][index]
                                    }

                                    ImageWiseCompare.push(imagewise_obj)
                                                     
                            })}
                            {ImageWiseCompare.length > 0 ? 
                        
                        <ReactTableExample data = {ImageWiseCompare} columns={ImageWiseCompareColumns}/>
                            : ""}
                            
                            </React.Fragment>
                            :""}
                                
                          
                      </div>
                                                                </div>
                                                                <div class="tab-pane fade " id="home-3" role="tabpanel" aria-labelledby="home-tab-3">
                                                                <div className="row">
            
                                                        <div className="col-md-2 offset-md-4 mr-0 pr-0">
                                                        <button className="btn btn-dark w-100  "  onClick={()=>this.exportProductWiseExcel()}>Export Report</button>
                                                        </div>
        
                      </div>
                      <div className="row ml-10 mt-6">
                         
                                {this.props.props.imgAlignment!=undefined && this.props.props.imgAlignment.Alignment!=undefined?
                            <React.Fragment>
                            {this.props.props.imgAlignment.Alignment[0].Product_code.map((imageName, index)=>{
                                   var ProductWiseObj = {} 

                                   ProductWiseObj = {
                                       "Product Name" : imageName[index],
                                       "Minimum" :  Number.parseFloat(this.props.props.imgAlignment.Alignment[5].Minimum[index][index] * 100).toFixed(2),
                                       "Maximum" : Number.parseFloat(this.props.props.imgAlignment.Alignment[6].Maximum[index][index] * 100).toFixed(2),
                                       "Median" : Number.parseFloat(this.props.props.imgAlignment.Alignment[7].Median[index][index] * 100).toFixed(2),
                                   } 
                                   if(ProductWiseCompare.length <= 0){
                                        ProductWiseCompare.push(ProductWiseObj)
                                   }
                                   else{
                                       var isObjPresent = this.containsObject(ProductWiseObj, ProductWiseCompare)
                                       if(!isObjPresent){
                                            ProductWiseCompare.push(ProductWiseObj)
                                       }
                                   }
                                                            
                            })}
                            
                            {ProductWiseCompare.length > 0 ?
                            
                            <ReactTableExample data = {ProductWiseCompare} columns={ProductWiseCompareColumns}/>
                             : 
                             ""  
                            }
                            </React.Fragment>:""}
                            
                               
                      </div>
                                                                </div>
                                                                
                                                            </div>
                                                            </React.Fragment>
     {/* }                   */}
                                                            
        </div>
       

        );
      }
    }
export default Tableanalyze;